import { deletedItemsLabel } from 'owa-locstrings/lib/strings/deleteditemslabel.locstring.json';
import {
    currentNavigation,
    searchResultsForPersonaLabel,
    favoritesListHeader,
    recoverableItemsLabel,
} from './personaListHeaderTitleSelector.locstring.json';
import { allLabel } from 'owa-locstrings/lib/strings/alllabel.locstring.json';
import {
    contactsLabel,
    yourContactsLabel,
} from 'owa-locstrings/lib/strings/contactslabel.locstring.json';
import {
    contactListsLabel,
    yourContactListsLabel,
} from 'owa-locstrings/lib/strings/contactlistslabel.locstring.json';
import loc from 'owa-localize';
import {
    favoritesLeftNavItemId,
    ContactFolder,
    contactsLeftNavItemId,
    contactListsLeftNavItemId,
    createSelector,
    deletedItemsLeftNavItemId,
    DeletedItemsSubViewType,
    isConsumer,
} from '../../shared';
import {
    AppState,
    SearchQuery,
    getActiveLeftNavItemId,
    getDisplayedContactFolders,
    isInEVNavigationMode,
    isInDeepLinkMode,
    isActiveLeftNavItemPublicFolder,
    getActiveLeftNavItemSparseFolder,
} from '../../appstate';
import type { HubState } from '../state';

export { ContactFolder, SearchQuery };

export const getPersonaListHeaderTitle = createSelector<
    AppState,
    HubState,
    string,
    ContactFolder[],
    ContactFolder,
    SearchQuery,
    boolean,
    boolean,
    boolean,
    ContactFolder[],
    boolean,
    ContactFolder,
    string
>(
    'getPersonaListHeaderTitle',
    [
        getActiveLeftNavItemId,
        getDisplayedContactFolders,
        (appState: AppState) => appState.data.contactFoldersState.defaultContactFolder,
        (appState: AppState) => appState.view.navigationState.currentQuery,
        isInEVNavigationMode,
        (appState: AppState, hubState: HubState) =>
            hubState?.view &&
            hubState.view.deletedItemsFolderState.deletedItemsSubViewType ===
                DeletedItemsSubViewType.RecoverableContactsFolder,
        isInDeepLinkMode,
        (appState: AppState) => appState.data.contactFoldersState.publicFolders,
        isActiveLeftNavItemPublicFolder,
        getActiveLeftNavItemSparseFolder,
    ],
    (
        activeLeftNavItemId,
        displayedContactFolders,
        defaultContactFolder,
        currentQuery,
        isInEVNavigationMode,
        isInRecoverableItems,
        isInDeepLinkMode,
        publicFolders,
        activeLeftNavItemIsPublicFolder,
        activeLeftNavItemSparseFolder
    ) => {
        if (isInEVNavigationMode || isInDeepLinkMode) {
            return loc(currentNavigation);
        }

        if (currentQuery) {
            return loc(searchResultsForPersonaLabel);
        }

        if (defaultContactFolder && defaultContactFolder.id === activeLeftNavItemId) {
            return defaultContactFolder.displayName;
        }

        if (activeLeftNavItemIsPublicFolder) {
            const folder = publicFolders.find(folder => folder.id === activeLeftNavItemId);
            return folder?.displayName;
        }

        if (activeLeftNavItemSparseFolder) {
            return activeLeftNavItemSparseFolder.displayName;
        }

        switch (activeLeftNavItemId) {
            case favoritesLeftNavItemId:
                return loc(favoritesListHeader);
            case contactsLeftNavItemId:
                return isConsumer() ? loc(contactsLabel) : loc(yourContactsLabel);
            case contactListsLeftNavItemId:
                return isConsumer() ? loc(contactListsLabel) : loc(yourContactListsLabel);
            case deletedItemsLeftNavItemId:
                // We masking Recoverable items for Consumers to be called as DeletedItems
                return isInRecoverableItems && !isConsumer()
                    ? loc(recoverableItemsLabel)
                    : loc(deletedItemsLabel);
            default:
                const folder = displayedContactFolders.find(
                    folder => folder.id === activeLeftNavItemId
                );

                if (folder) {
                    return folder.displayName;
                }

                return loc(allLabel);
        }
    }
);
export { ClickedHubPersonaState } from '../../appstate';
